<template>
    <div class="dashboard__view mb-5">
        <div class="list" style="padding-bottom: 40px; padding: 28px;">
            <div class="tabs">
                <div :class="activeTab === 'single' ? 'active' : ''" @click="activeTab = 'single'">Single</div>
                <div :class="activeTab === 'bulk' ? 'active' : ''" @click="activeTab = 'bulk'">Bulk Upload</div>
            </div>
            <div class="single" v-if="activeTab === 'single'">
                <div class="main-section">
                    <div class="text">
                        <div class="">Create Blacklist</div>
                        <div class="text-[#261940]">Be sure to enter correct details and Merchant Information</div>
                    </div>
                    <div class="single-input">
                        <div class="">
                            <label>ID Number</label>
                            <input type="text" placeholder="ID number" v-model="id_number">
                        </div>
                        <div class="">
                            <label>Name</label>
                            <input type="text" placeholder="name" v-model="name">
                        </div>
                        <div class="">
                            <label>Type</label>
                            <select v-model="id_type">
                                <option value="NIN">NIN</option>
                                <option value="BVN">BVN</option>
                                <option value="ACCOUNT_NUMBER">ACCOUNT_NUMBER</option>
                            </select>
                        </div>
                        <div class="">
                            <label>Class</label>
                            <select v-model="blacklist_class">
                                <option value="Temporary">Temporary</option>
                                <option value="Permanent">Permanent</option>
                            </select>
                        </div>
                        <div class="">
                            <label>Source</label>
                            <input type="text" placeholder="source" v-model="source">
                        </div>
                        <div class="">
                            <label>Reason</label>
                            <textarea rows="5" v-model="reason"></textarea>
                        </div>
                    </div>
                </div>
                <div class="btn_container">
                    <button class="btn woven-color pt-3 pb-4" @click.prevent="createBlacklist" :disabled="disabled">Submit</button>
                </div>
            </div>
            <div class="" v-if="activeTab === 'bulk'">
                <div class="main-section">
                    <div class="text">
                        <div class="">Bulk Blacklist</div>
                        <div class="text-[#261940]">Be sure to enter correct details and Customer Information</div>
                    </div>
                    <div class="import">
                        <div class="">
                            <addDocument
                                label="Upload CSV"
                                allowed-formats=".csv, .xls, .xlsx"
                                :on-change="handleFileUpload"
                            />
                        </div>
                        <a class="download" href="/sample-bulkblacklist.csv">Download bulk blacklist template</a>
                    </div>
                </div>
                <table class="table card-table" style="margin: auto; margin-top: 40px; margin-bottom: 40px;" v-if="previewBlacklist.length > 0">
                  <thead>
                    <tr>
                      <th>ID Number</th>
                      <th>name</th>
                      <th>type</th>
                      <th>source</th>
                      <th>class</th>
                      <th style="text-align: left;">reason</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                    :key="item.id_number"
                        v-for="item in previewBlacklist"
                    >
                        <td>{{ item.id_number }}</td>
                        <td>{{ item.name }}</td>
                        <td>{{ item.id_type }}</td>
                        <td>{{ item.source }}</td>
                        <td>{{ item.class ? (item.class.substring(0,1).toUpperCase() + item.class.substring(1).toLowerCase()) : "Not Available" }}</td>
                        <td style="text-align: left;">{{ item.reason }}</td>
                        <td @click="removeBlacklist(item.id_number)"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style="height: 12px;" fill="red"><path d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3zM32 128l384 0 0 320c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-320zm96 64c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16z"/></svg></td>
                    </tr>
                  </tbody>
                </table>
                <div class="btn_container" v-if="previewBlacklist.length > 0">
                    <button class="btn woven-color pt-3 pb-4" @click.prevent="uploadBulk">Bulk Upload</button>
                </div>
            </div>
        </div>
    </div>
  </template>
  <script>
  import addDocument from "../../../components/addDocument.vue";
  import Papa from 'papaparse';
  export default {
    metaInfo: {
      title: "Merchant Details",
    },
    components: {
        addDocument
    },
    data() {
      return {
        previewBlacklist: [],
        activeTab: 'single',
        id_number: '',
        name: '',
        id_type: '',
        blacklist_class: '',
        source: '',
        reason: '',
        loading: false,
      };
    },
    computed: {
        disabled() {
            return !this.loading && this.id_number && this.name && this.id_type && this.source && this.reason && this.blacklist_class ? false : true;
        },
    },
    methods: {
        handleFileUpload(file) {
            const fileReader = new FileReader();
            fileReader.onload = () => {
                Papa.parse(fileReader.result, {
                header: true,
                skipEmptyLines: true,
                complete: (results) => {
                    let result = results.data.filter(item => item.id_number && item.name && item.id_type && item.source && item.reason && item.class).map(i => ({ ...i, class: i.class.toUpperCase() }));
                    if(result.length === 0) {
                        this.$notify({
                            group: "notifications-default",
                            type: "error text-white",
                            title: "Error",
                            text: "Please ensure the file has the correct format and all required fields are filled.",
                        });
                    }
                    this.previewBlacklist = result;
                },
                error: () => {
                    this.$notify({
                        group: "notifications-default",
                        type: "error text-white",
                        title: "Error",
                        text: "Error parsing file. Please ensure the file has the correct format.",
                    });
                }
                });
            };
            fileReader.readAsText(file);
        },
        removeBlacklist(index) {
            this.previewBlacklist = this.previewBlacklist.filter((i) => i.id_number !== index);
        },
        createBlacklist() {
            this.loading = true;
            const payload = {
                id_number: this.id_number,
                name: this.name,
                id_type: this.id_type,
                source: this.source,
                reason: this.reason,
                class: this.blacklist_class.toUpperCase(),
            };
            this.$http
            .post(`blacklists`, payload)
            .then(() => {
                this.$notify({
                    group: "notifications-default",
                    type: "success text-white",
                    title: "Success",
                    text: "Blacklist created successfully",
                });
                this.$router.push('/dashboard/blacklists/approved');
            })
            .catch((error) => {
                this.loading = false;
                this.$notify({
                    group: "notifications-default",
                    type: "error text-white",
                    title: "Error",
                    text: error.body.status || "An error occured.",
                });
            });
        },
        uploadBulk() {
            this.loading = true;
            const csv = Papa.unparse(this.previewBlacklist);
            const blob = new Blob([csv], { type: 'text/csv' });
            const formData = new FormData();
            formData.append('blacklists', blob, 'blacklist.csv');
            this.$http
            .post(`blacklists`, formData)
            .then((response) => {
                if(!response.body.data) throw new Error();
                const validEntries =  response.body.data.filter(i => i.status === 'success');
                if(validEntries.length > 0){
                    this.$notify({
                        group: "notifications-default",
                        type: "success text-white",
                        title: "Success",
                        text: validEntries.length + " blacklists created successfully" || "Blacklists created successfully",
                    });
                    this.$router.push('/dashboard/blacklists/approved');
                }else{
                    this.$notify({
                        group: "notifications-default",
                        type: "error text-white",
                        title: "Error",
                        text: "No valid entries from imported file",
                    });
                }
            })
            .catch((error) => {
                this.loading = false;
                this.$notify({
                    group: "notifications-default",
                    type: "error text-white",
                    title: "Error",
                    text: error.body.message || "An error occured.",
                });
            });
        },
    },
    watch: {
        activeTab(newVal) {
            if (newVal === 'single') {
                this.previewBlacklist = [];
            }
        },
    },
  };
</script>
 <style>
 .btn_container{
    width: 100%;
    display: flex;
    justify-content: flex-end;
 }
 .btn{
    height: 40px;
    background-color: #e00b5b !important;
    border-radius: 4px !important;
    color: white !important;
    align-self: flex-end;
 }
 .tabs{
    display: flex;
    align-items: center;
    gap: 50px;
    font-size: 18px;
    >div{
        cursor: pointer;
    }
    >div.active{
        border-bottom: solid 1px black;
    }
 }
 .text{
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 12px;
}
.single{ 
    .text{
        justify-content: flex-start !important;
    }
    .main-section{
        align-items: flex-start;
        padding: 0px;
        padding-top: 30px;
        padding-bottom: 30px;
    }

}
 .main-section{
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    padding: 28px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 18px;
    margin: auto;
    gap: 100px;
    >div{
        width: 100%;
    }
    >div:first-child >div:first-child{
        color: #e00b5b;
        font-weight: 600;
        font-size: 24px;
    }
    >div:first-child >div:last-child{
        color: #261940;
        font-size: 18px;
    }
    .add-document{
        width: fit-content;
        min-width: 300px;
        justify-self: end;
    }
 }
 .download{
    color: #e00b5b;
    cursor: pointer;
 }
 .import{
    text-align: right;
 }
 .single-input{
    display: flex;
    flex-direction: column;
    gap: 20px;
    input, textarea, select{
        width: 100%;
        height: 48px;
        border-radius: 4px;
        border: solid 1px #e0e0e0;
        padding: 8px;
        padding: 16px;
        font-size: 14px;   
        outline: none;
        color: #55595c;
    }
    textarea{
        outline: none;
        height: 200px;
    }
 }
 label{
    color: #616e7c;
    font-size: 14px;
 }
</style> 